import { IBaseCellsProps } from '../cells.interfaces';
import { StyledTableCell } from './CellIconButton.styles';
import { Icon, IconButton, Theme, useTheme } from '../../../base-components';
import { IRowData } from '../../table.interfaces';

interface Props extends IBaseCellsProps {
    isHeaderCell?: boolean;
    disabled?: boolean;
    data: {
        iconName: string;
        iconColor: string;
        iconSize: number;
    };
    onButtonClick: (item: IRowData) => void;
}

const CellIconButton = (props: Props) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
        isHeaderCell = false,
        disabled = false,
        data = { iconName: '', iconColor: '', iconSize: 0 },
        onButtonClick,
        rowData,
    } = props;
    const theme = useTheme();
    const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        onButtonClick(rowData);
    };

    const getIconColor = (color: string, theme: Theme) => {
        // Check if the color is a theme color name

        const themeColors = [
            'primary',
            'secondary',
            'info',
            'success',
            'warning',
            'error',
        ];
        if (themeColors.includes(color)) {
            return theme.palette[color as keyof typeof theme.palette].main;
        }
        // If not a theme color, return the color as is
        return color;
    };

    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
            isHeaderCell={isHeaderCell}
            onClick={(e: React.MouseEvent<HTMLElement>) => e.stopPropagation()}
        >
            <IconButton
                disabled={disabled}
                onClick={(e: React.MouseEvent<HTMLElement>) =>
                    handleButtonClick(e)
                }
                sx={{ height: 28, width: 28 }}
            >
                <Icon
                    name={data.iconName}
                    color={
                        data.iconColor
                            ? getIconColor(data.iconColor, theme)
                            : theme.palette.primary.main
                    }
                    size={data.iconSize}
                />
            </IconButton>
        </StyledTableCell>
    );
};

export default CellIconButton;
